<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="名称"
                    prop="appUserName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.appUserName"
                      disabled
                    >
                      <el-button
                        v-if="eventType!=='view'"
                        slot="append"
                        icon="el-icon-search"
                        @click="showUserFun()"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="店名"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="专卖证号"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.certificateNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本香门店码"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.benxiangStoreNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="类型"
                    prop="type"
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.type"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        全部
                      </el-radio>
                      <el-radio :label="2">
                        宣介会
                      </el-radio>
                      <el-radio :label="3">
                        微信活动
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="开始时间"
                    prop="startDate"
                  >
                    <el-date-picker
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.startDate"
                      type="date"
                      class="data-picker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                    />
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.startDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="结束时间"
                    prop="endDate"
                  >
                    <el-date-picker
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.endDate"
                      type="date"
                      class="data-picker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                    />
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.endDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="状态"
                    prop="status"
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.status"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        启用
                      </el-radio>
                      <el-radio :label="2">
                        停用
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 用户列表 -->
    <user-list-dialog
      :dialog-visible.sync="dialogUserVisible"
      dialog-title="用户信息"
      @selectedUserFun="selectedUserFun"
    />
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 用户
import userListDialog from './userListDialog'
// 数据请求
import { initAppUserBlacklistApi, saveOrUpdateAppUserBlacklistApi } from '@/api/appUserBlacklist'
export default {
  components: { userListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        startDate: [ { required: true, message: '请选择开始时间', trigger: 'change' }],
        endDate: [ { required: true, message: '请选择结束时间', trigger: 'change' }],
        type: [ { required: true, message: '请选择类型', trigger: 'change' }],
        status: [ { required: true, message: '请选择状态', trigger: 'change' }],
        appUserName: [ { required: true, message: '请输入选择零售户', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' } ]
      },
      dialogUserVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          appUserId: '',
          appUserName: '',
          provinceName: '',
          cityName: '',
          phone: '',
          storeName: '',
          certificateNo: '',
          benxiangStoreNo: '',
          type: 1,
          startDate: '',
          endDate: '',
          status: 1,
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initActivityPlaceData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initActivityPlaceData () {
      initAppUserBlacklistApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm){
          if(key !== 'startDate' && key !== 'endDate'){
            this.dialogAddEditViewForm[key] = data[key]
          }
        }
        this.dialogAddEditViewForm.startDate = data.startDateStr
        this.dialogAddEditViewForm.endDate = data.endDateStr
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 弹出用户选择
    showUserFun(){
      this.dialogUserVisible = true
    },
    // 选择用户
    selectedUserFun(val){
      this.dialogAddEditViewForm.appUserId = val.id
      this.dialogAddEditViewForm.appUserName = val.name
      this.dialogAddEditViewForm.provinceName = val.provinceName
      this.dialogAddEditViewForm.cityName = val.cityName
      this.dialogAddEditViewForm.phone = val.phone
      this.dialogAddEditViewForm.storeName = val.storeName
      this.dialogAddEditViewForm.certificateNo = val.certificateNo
      this.dialogAddEditViewForm.benxiangStoreNo = val.benxiangStoreNo
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          let startDateNum = String(this.dialogAddEditViewForm.startDate).replace('-','').replace('-','')
          let endDateNum = String(this.dialogAddEditViewForm.endDate).replace('-','').replace('-','')
          if(Number(startDateNum) > Number(endDateNum)){
            this.$message.error('开始日期不能大于结束日期')
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '微信零售户黑名单','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave () {
      saveOrUpdateAppUserBlacklistApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>

</style>
